// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.button {
  border-radius: var(--ce-border-radius-default);
  border: 1px solid transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  position: relative;
  font-family: var(--ce-font-family-body);
  font-weight: 500;
  transition-duration: var(--ce-transition-duration);
  gap: calc(var(--ce-interactable-padding-default) - 3px);
  line-height: 1.3;
}

a.button {
  text-decoration: none;
}

/* -------------------------------- */
/* SIZES */
/* -------------------------------- */
.button.size-small {
  font-size: var(--text_sm);
  border-radius: var(--ce-border-radius-small);
  padding: var(--ce-interactable-padding-small);
  gap: calc(var(--ce-interactable-padding-small) - 3px);
}
.button.size-small .loading-icon svg {
  max-width: var(--text_sm);
  max-height: var(--text_sm);
}
/* Expanding the touch target */
.button.size-small:before {
  content: '';
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
}
.button.size-default {
  font-size: var(--text_md);
  padding: var(--ce-interactable-padding-default);
  min-width: var(--ideal_touch_target);
  min-height: var(--ideal_touch_target);
}
.button.size-default.variant-round {
  border-radius: 27.5px;
  min-width: 44px;
}
.button.size-default .loading-icon.spinner svg {
  max-width: 26px;
  max-height: 26px;
}
.button.size-large {
  font-size: var(--text_lg);
  padding: var(--ce-interactable-padding-large);
  gap: calc(var(--ce-interactable-padding-large) - 3px);
}
.button.size-large .loading-icon svg {
  max-width: var(--text_lg);
  max-height: var(--text_lg);
}

/* -------------------------------- */
/* INTENT / COLORS */
/* -------------------------------- */

/* TODO: do we still need this? */
/* Default */
.button .loading-icon svg {
  fill: #fff;
}

/* ---------------------- */
/* Primary */
/* ---------------------- */
.button.intent-primary,
.button.intent-primary.variant-filled {
  background-color: var(--ce-intent-primary);
  color: var(--ce-intent-primary-contrast);
}
.button.intent-primary .loading-icon svg {
  fill: var(--ce-intent-primary-contrast) !important;
}
.button.intent-primary.variant-minimal .loading-icon svg {
  fill: var(--ce-intent-primary) !important;
}
.button.intent-primary:hover,
.button.intent-primary.variant-filled:hover {
  background-color: var(--ce-intent-primary-faded);
}
a.button.intent-primary:focus,
e button.button.intent-primary:focus,
a.button.intent-primary.variant-filled:focus,
button.button.intent-primary.variant-filled:focus {
  outline: none;
  box-shadow: 0px 0px 0px 2px var(--ce-intent-primary-outline);
}
.button.intent-primary.variant-minimal {
  background-color: transparent;
  border-color: transparent;
  color: var(--ce-intent-primary);
}
/* ---------------------- */
/* Secondary */
/* ---------------------- */
.button.intent-secondary,
.button.intent-secondary.variant-filled {
  background-color: var(--ce-intent-secondary);
  color: var(--ce-intent-secondary-contrast);
}
.button.intent-secondary .loading-icon svg {
  fill: var(--ce-intent-secondary-contrast) !important;
}
.button.intent-secondary.variant-minimal .loading-icon svg {
  fill: var(--ce-intent-secondary) !important;
}
.button.intent-secondary:hover,
.button.intent-secondary.variant-filled:hover {
  background-color: var(--ce-intent-secondary-faded);
}
a.button.intent-secondary:focus,
e button.button.intent-secondary:focus,
a.button.intent-secondary.variant-filled:focus,
button.button.intent-secondary.variant-filled:focus {
  outline: none;
  box-shadow: 0px 0px 0px 2px var(--ce-intent-secondary-outline);
}
.button.intent-secondary.variant-minimal {
  background-color: transparent;
  border-color: transparent;
  color: var(--ce-intent-secondary);
}
/* ---------------------- */
/* None */
/* ---------------------- */
.button.intent-none,
.button.intent-none.variant-filled {
  background-color: var(--ce-intent-none);
  color: var(--ce-intent-none-contrast);
}
.button.intent-none .loading-icon svg {
  fill: var(--ce-intent-none-contrast) !important;
}
.button.intent-none.variant-minimal .loading-icon svg {
  fill: var(--ce-intent-none) !important;
}
.button.intent-none:hover,
.button.intent-none.variant-filled:hover {
  background-color: var(--ce-intent-none-faded);
}
a.button.intent-none:focus,
e button.button.intent-none:focus,
a.button.intent-none.variant-filled:focus,
button.button.intent-none.variant-filled:focus {
  outline: none;
  box-shadow: 0px 0px 0px 2px var(--ce-intent-none-outline);
}
.button.intent-none.variant-minimal {
  background-color: transparent;
  border-color: transparent;
  color: var(--ce-intent-none);
}
/* ---------------------- */
/* Success */
/* ---------------------- */
.button.intent-success,
.button.intent-success.variant-filled {
  background-color: var(--ce-intent-success);
  color: var(--ce-intent-success-contrast);
}
.button.intent-success .loading-icon svg {
  fill: var(--ce-intent-success-contrast) !important;
}
.button.intent-success.variant-minimal .loading-icon svg {
  fill: var(--ce-intent-success) !important;
}
.button.intent-success:hover,
.button.intent-success.variant-filled:hover {
  background-color: var(--ce-intent-success-faded);
}
a.button.intent-success:focus,
e button.button.intent-success:focus,
a.button.intent-success.variant-filled:focus,
button.button.intent-success.variant-filled:focus {
  outline: none;
  box-shadow: 0px 0px 0px 2px var(--ce-intent-success-outline);
}
.button.intent-success.variant-minimal {
  background-color: transparent;
  border-color: transparent;
  color: var(--ce-intent-success);
}
/* ---------------------- */
/* Warning */
/* ---------------------- */
.button.intent-warning,
.button.intent-warning.variant-filled {
  background-color: var(--ce-intent-warning);
  color: var(--ce-intent-warning-contrast);
}
.button.intent-warning .loading-icon svg {
  fill: var(--ce-intent-warning-contrast) !important;
}
.button.intent-warning.variant-minimal .loading-icon svg {
  fill: var(--ce-intent-warning) !important;
}
.button.intent-warning:hover,
.button.intent-warning.variant-filled:hover {
  background-color: var(--ce-intent-warning-faded);
}
a.button.intent-warning:focus,
e button.button.intent-warning:focus,
a.button.intent-warning.variant-filled:focus,
button.button.intent-warning.variant-filled:focus {
  outline: none;
  box-shadow: 0px 0px 0px 2px var(--ce-intent-warning-outline);
}
.button.intent-warning.variant-minimal {
  background-color: transparent;
  border-color: transparent;
  color: var(--ce-intent-warning);
}
/* ---------------------- */
/* Danger */
/* ---------------------- */
.button.intent-danger,
.button.intent-danger.variant-filled {
  background-color: var(--ce-intent-danger);
  color: var(--ce-intent-danger-contrast);
}
.button.intent-danger .loading-icon svg {
  fill: var(--ce-intent-danger-contrast) !important;
}
.button.intent-danger.variant-minimal .loading-icon svg {
  fill: var(--ce-intent-danger) !important;
}
.button.intent-danger:hover,
.button.intent-danger.variant-filled:hover {
  background-color: var(--ce-intent-danger-faded);
}
a.button.intent-danger:focus,
e button.button.intent-danger:focus,
a.button.intent-danger.variant-filled:focus,
button.button.intent-danger.variant-filled:focus {
  outline: none;
  box-shadow: 0px 0px 0px 2px var(--ce-intent-danger-outline);
}
.button.intent-danger.variant-minimal {
  background-color: transparent;
  border-color: transparent;
  color: var(--ce-intent-danger);
}

/* -------------------------------- */
/* TEXT ALIGNMENT */
/* -------------------------------- */
.button.align-text-left {
  text-align: left;
  justify-content: flex-start;
}

.button.align-text-center {
  text-align: center;
  justify-content: center;
}

.button.align-text-right {
  text-align: right;
  justify-content: flex-end;
}

.button-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.button.loading,
.button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.button .loading-icon {
  margin-bottom: 0;
}

.button .iconLeft,
.button .iconRight {
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/presentational/Button/Button.css"],"names":[],"mappings":";AACA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,kDAAkD;EAClD,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC,UAAU;AACV,qCAAqC;AACrC;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,6CAA6C;EAC7C,qDAAqD;AACvD;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,qDAAqD;AACvD;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC,oBAAoB;AACpB,qCAAqC;;AAErC,iCAAiC;AACjC,YAAY;AACZ;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B,YAAY;AACZ,2BAA2B;AAC3B;;EAEE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,kDAAkD;AACpD;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,gDAAgD;AAClD;AACA;;;;EAIE,aAAa;EACb,4DAA4D;AAC9D;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;AACjC;AACA,2BAA2B;AAC3B,cAAc;AACd,2BAA2B;AAC3B;;EAEE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,2CAA2C;AAC7C;AACA;;EAEE,kDAAkD;AACpD;AACA;;;;EAIE,aAAa;EACb,8DAA8D;AAChE;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iCAAiC;AACnC;AACA,2BAA2B;AAC3B,SAAS;AACT,2BAA2B;AAC3B;;EAEE,uCAAuC;EACvC,qCAAqC;AACvC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,6CAA6C;AAC/C;AACA;;;;EAIE,aAAa;EACb,yDAAyD;AAC3D;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA,2BAA2B;AAC3B,YAAY;AACZ,2BAA2B;AAC3B;;EAEE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,kDAAkD;AACpD;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,gDAAgD;AAClD;AACA;;;;EAIE,aAAa;EACb,4DAA4D;AAC9D;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;AACjC;AACA,2BAA2B;AAC3B,YAAY;AACZ,2BAA2B;AAC3B;;EAEE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,kDAAkD;AACpD;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,gDAAgD;AAClD;AACA;;;;EAIE,aAAa;EACb,4DAA4D;AAC9D;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;AACjC;AACA,2BAA2B;AAC3B,WAAW;AACX,2BAA2B;AAC3B;;EAEE,yCAAyC;EACzC,uCAAuC;AACzC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,wCAAwC;AAC1C;AACA;;EAEE,+CAA+C;AACjD;AACA;;;;EAIE,aAAa;EACb,2DAA2D;AAC7D;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC,mBAAmB;AACnB,qCAAqC;AACrC;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["\n.button {\n  border-radius: var(--ce-border-radius-default);\n  border: 1px solid transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  flex-direction: row;\n  position: relative;\n  font-family: var(--ce-font-family-body);\n  font-weight: 500;\n  transition-duration: var(--ce-transition-duration);\n  gap: calc(var(--ce-interactable-padding-default) - 3px);\n  line-height: 1.3;\n}\n\na.button {\n  text-decoration: none;\n}\n\n/* -------------------------------- */\n/* SIZES */\n/* -------------------------------- */\n.button.size-small {\n  font-size: var(--text_sm);\n  border-radius: var(--ce-border-radius-small);\n  padding: var(--ce-interactable-padding-small);\n  gap: calc(var(--ce-interactable-padding-small) - 3px);\n}\n.button.size-small .loading-icon svg {\n  max-width: var(--text_sm);\n  max-height: var(--text_sm);\n}\n/* Expanding the touch target */\n.button.size-small:before {\n  content: '';\n  position: absolute;\n  top: -6px;\n  left: -6px;\n  right: -6px;\n  bottom: -6px;\n}\n.button.size-default {\n  font-size: var(--text_md);\n  padding: var(--ce-interactable-padding-default);\n  min-width: var(--ideal_touch_target);\n  min-height: var(--ideal_touch_target);\n}\n.button.size-default.variant-round {\n  border-radius: 27.5px;\n  min-width: 44px;\n}\n.button.size-default .loading-icon.spinner svg {\n  max-width: 26px;\n  max-height: 26px;\n}\n.button.size-large {\n  font-size: var(--text_lg);\n  padding: var(--ce-interactable-padding-large);\n  gap: calc(var(--ce-interactable-padding-large) - 3px);\n}\n.button.size-large .loading-icon svg {\n  max-width: var(--text_lg);\n  max-height: var(--text_lg);\n}\n\n/* -------------------------------- */\n/* INTENT / COLORS */\n/* -------------------------------- */\n\n/* TODO: do we still need this? */\n/* Default */\n.button .loading-icon svg {\n  fill: #fff;\n}\n\n/* ---------------------- */\n/* Primary */\n/* ---------------------- */\n.button.intent-primary,\n.button.intent-primary.variant-filled {\n  background-color: var(--ce-intent-primary);\n  color: var(--ce-intent-primary-contrast);\n}\n.button.intent-primary .loading-icon svg {\n  fill: var(--ce-intent-primary-contrast) !important;\n}\n.button.intent-primary.variant-minimal .loading-icon svg {\n  fill: var(--ce-intent-primary) !important;\n}\n.button.intent-primary:hover,\n.button.intent-primary.variant-filled:hover {\n  background-color: var(--ce-intent-primary-faded);\n}\na.button.intent-primary:focus,\ne button.button.intent-primary:focus,\na.button.intent-primary.variant-filled:focus,\nbutton.button.intent-primary.variant-filled:focus {\n  outline: none;\n  box-shadow: 0px 0px 0px 2px var(--ce-intent-primary-outline);\n}\n.button.intent-primary.variant-minimal {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--ce-intent-primary);\n}\n/* ---------------------- */\n/* Secondary */\n/* ---------------------- */\n.button.intent-secondary,\n.button.intent-secondary.variant-filled {\n  background-color: var(--ce-intent-secondary);\n  color: var(--ce-intent-secondary-contrast);\n}\n.button.intent-secondary .loading-icon svg {\n  fill: var(--ce-intent-secondary-contrast) !important;\n}\n.button.intent-secondary.variant-minimal .loading-icon svg {\n  fill: var(--ce-intent-secondary) !important;\n}\n.button.intent-secondary:hover,\n.button.intent-secondary.variant-filled:hover {\n  background-color: var(--ce-intent-secondary-faded);\n}\na.button.intent-secondary:focus,\ne button.button.intent-secondary:focus,\na.button.intent-secondary.variant-filled:focus,\nbutton.button.intent-secondary.variant-filled:focus {\n  outline: none;\n  box-shadow: 0px 0px 0px 2px var(--ce-intent-secondary-outline);\n}\n.button.intent-secondary.variant-minimal {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--ce-intent-secondary);\n}\n/* ---------------------- */\n/* None */\n/* ---------------------- */\n.button.intent-none,\n.button.intent-none.variant-filled {\n  background-color: var(--ce-intent-none);\n  color: var(--ce-intent-none-contrast);\n}\n.button.intent-none .loading-icon svg {\n  fill: var(--ce-intent-none-contrast) !important;\n}\n.button.intent-none.variant-minimal .loading-icon svg {\n  fill: var(--ce-intent-none) !important;\n}\n.button.intent-none:hover,\n.button.intent-none.variant-filled:hover {\n  background-color: var(--ce-intent-none-faded);\n}\na.button.intent-none:focus,\ne button.button.intent-none:focus,\na.button.intent-none.variant-filled:focus,\nbutton.button.intent-none.variant-filled:focus {\n  outline: none;\n  box-shadow: 0px 0px 0px 2px var(--ce-intent-none-outline);\n}\n.button.intent-none.variant-minimal {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--ce-intent-none);\n}\n/* ---------------------- */\n/* Success */\n/* ---------------------- */\n.button.intent-success,\n.button.intent-success.variant-filled {\n  background-color: var(--ce-intent-success);\n  color: var(--ce-intent-success-contrast);\n}\n.button.intent-success .loading-icon svg {\n  fill: var(--ce-intent-success-contrast) !important;\n}\n.button.intent-success.variant-minimal .loading-icon svg {\n  fill: var(--ce-intent-success) !important;\n}\n.button.intent-success:hover,\n.button.intent-success.variant-filled:hover {\n  background-color: var(--ce-intent-success-faded);\n}\na.button.intent-success:focus,\ne button.button.intent-success:focus,\na.button.intent-success.variant-filled:focus,\nbutton.button.intent-success.variant-filled:focus {\n  outline: none;\n  box-shadow: 0px 0px 0px 2px var(--ce-intent-success-outline);\n}\n.button.intent-success.variant-minimal {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--ce-intent-success);\n}\n/* ---------------------- */\n/* Warning */\n/* ---------------------- */\n.button.intent-warning,\n.button.intent-warning.variant-filled {\n  background-color: var(--ce-intent-warning);\n  color: var(--ce-intent-warning-contrast);\n}\n.button.intent-warning .loading-icon svg {\n  fill: var(--ce-intent-warning-contrast) !important;\n}\n.button.intent-warning.variant-minimal .loading-icon svg {\n  fill: var(--ce-intent-warning) !important;\n}\n.button.intent-warning:hover,\n.button.intent-warning.variant-filled:hover {\n  background-color: var(--ce-intent-warning-faded);\n}\na.button.intent-warning:focus,\ne button.button.intent-warning:focus,\na.button.intent-warning.variant-filled:focus,\nbutton.button.intent-warning.variant-filled:focus {\n  outline: none;\n  box-shadow: 0px 0px 0px 2px var(--ce-intent-warning-outline);\n}\n.button.intent-warning.variant-minimal {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--ce-intent-warning);\n}\n/* ---------------------- */\n/* Danger */\n/* ---------------------- */\n.button.intent-danger,\n.button.intent-danger.variant-filled {\n  background-color: var(--ce-intent-danger);\n  color: var(--ce-intent-danger-contrast);\n}\n.button.intent-danger .loading-icon svg {\n  fill: var(--ce-intent-danger-contrast) !important;\n}\n.button.intent-danger.variant-minimal .loading-icon svg {\n  fill: var(--ce-intent-danger) !important;\n}\n.button.intent-danger:hover,\n.button.intent-danger.variant-filled:hover {\n  background-color: var(--ce-intent-danger-faded);\n}\na.button.intent-danger:focus,\ne button.button.intent-danger:focus,\na.button.intent-danger.variant-filled:focus,\nbutton.button.intent-danger.variant-filled:focus {\n  outline: none;\n  box-shadow: 0px 0px 0px 2px var(--ce-intent-danger-outline);\n}\n.button.intent-danger.variant-minimal {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--ce-intent-danger);\n}\n\n/* -------------------------------- */\n/* TEXT ALIGNMENT */\n/* -------------------------------- */\n.button.align-text-left {\n  text-align: left;\n  justify-content: flex-start;\n}\n\n.button.align-text-center {\n  text-align: center;\n  justify-content: center;\n}\n\n.button.align-text-right {\n  text-align: right;\n  justify-content: flex-end;\n}\n\n.button-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.button.loading,\n.button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.button .loading-icon {\n  margin-bottom: 0;\n}\n\n.button .iconLeft,\n.button .iconRight {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
